import { useTranslation } from 'react-i18next';
import { Search, Command, Globe, type LucideIcon } from 'lucide-react';
import { Section } from '../Section';
import { FeatureCard } from '../FeatureCard';

const ITEMS: { key: string; icon: LucideIcon }[] = [
  { key: 'search', icon: Search },
  { key: 'palette', icon: Command },
  { key: 'save', icon: Globe },
];

export function HomeEssentials() {
  const { t } = useTranslation();

  return (
    <div id="how">
      <Section title={t('home.essentials.title')}>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
          {ITEMS.map(({ key, icon }) => (
            <FeatureCard key={key} icon={icon} title={t(`home.essentials.items.${key}.title`)}>
              {t(`home.essentials.items.${key}.copy`)}
            </FeatureCard>
          ))}
        </div>
      </Section>
    </div>
  );
}
